module.exports = __webpack_public_path__ + "img/a-mrcj-banner@2x.f67bd8c1.png";